import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Skeleton } from 'antd';
import AntPagination from 'common/AntTablePagination';
import utils, {  getDecryptedUrl, getUrlWithEncryptedQueryParams } from 'lib/utils';
import { actions as logActions } from 'redux/iProfitERPLogs';
import { Link, useHistory } from 'react-router-dom';
import useQuery from 'lib/hooks/useQuery';
import NumericSearchFilter from 'common/Form/AntFilters/NumericSearchFilter';
import AutoCompleteFilter from 'common/Form/AntFilters/AutoCompleteFilter';
import TextSearchFilter from 'common/Form/AntFilters/TextSearchFilter';
import RangeDateSearchFilter from 'common/Form/AntFilters/RangeDateSearchFilter';
import FilterUtils from 'lib/filterUtils';
import TableListHeader from 'common/TableListHeader';
import { getLinks } from 'constants/linkConfig';
import MUIAutocomplete from 'common/MUIComponents/Autocomplete';
import MUIButton from 'common/MUIComponents/Button';
import ClosingDateField from 'common/TableComponents/closingDateField';
import CancelIcon from '@material-ui/icons/Cancel';
import RetryIcon from '@material-ui/icons/Replay';
import { iProfitERPService } from 'services';
import { SearchOutlined, FilterOutlined, CalendarOutlined } from '@ant-design/icons';

const Logs = () => {
  const {
    page = 1,
    activeTab,
    option: lOption,
    id,
    created_datetime,
    success_fail,
    message,
    error_message,
    method,
    iprofit_erp_module_enum,
    module_entity_code,
  } = useQuery();
  const history = useHistory();

  const dispatch = useDispatch();
  const tableRef = useRef();

  const logsState = useSelector((state) => state.iProfitERPLogs);
  const logs = logsState?.logs;
  const busy = logsState?.busy;

  const [links, setLinks] = useState([]);

  const context = useSelector((state) => state.context);
  const userInfo = useSelector((state) => state.user);
  const sid = _.get(userInfo, 'social_profile_id', 0);
  const socialProfiles = useSelector((state) => state.socialProfiles);
  const profileData = _.get(socialProfiles, `data[${sid}]`) || {};
  const partnerId = _.get(profileData, 'partner_id') || null;
  const isControlTowerUser = _.get(userInfo, 'profile.person.is_control_tower_user') || false;
  const isSupplyPartner = _.get(userInfo, 'profile.is_supply_partner') || false;
  const isTransporter = _.get(userInfo, 'profile.person.is_transporter') || false;
  const typeOfIndividualEnum = _.get(userInfo, 'profile.person.type_of_individual_enum') || 0;
  const is_zoho_connected = userInfo?.profile?.is_connected;
  const loc = getDecryptedUrl(window.location.href);
  const rolesAndRights = useSelector((state) => state.rolesAndRights);
  const rolesAndRightsList = _.get(rolesAndRights, 'entities') || {};

  const logOptions = [
                      { label: 'API Logs', value: 'api-logs' },
                      { label: 'Exceptions', value: 'exceptions' },
                      // { label: 'Mappings', value: 'mappings' }
                    ];
  const [logOption, setLogOption] = useState(lOption || logOptions[0].value);

  const [filters, setFilters] = useState({});
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [scrollToFirstRow, setScrollToFirstRow] = useState(false);
  const [activeTabTemp, setActiveTabTemp] = useState('');

  useEffect(() => {
    const fetchedLinks = getLinks(isSupplyPartner,isControlTowerUser, isTransporter, typeOfIndividualEnum, context, loc, is_zoho_connected, activeTab, partnerId,userInfo,rolesAndRightsList);
    setLinks(fetchedLinks);
  }, [context.ctx]);

  useEffect(() => {
    if (context.ctx === '2') {
      setActiveTabTemp('market');
    } else if (context.ctx === '4') {
      setActiveTabTemp('network');
    } else if (context.ctx === '5') {
      setActiveTabTemp('CT');
    }
  }, [context.ctx])

  useEffect(() => {
    if (scrollToFirstRow && tableRef.current) {
      const firstRow = tableRef.current.querySelector('.ant-table-row');
      if (firstRow) {
        firstRow.scrollIntoView({ behavior: 'smooth' });
      }
      setScrollToFirstRow(false);
    }
  }, [scrollToFirstRow]);

  const getFilteredParams = () => {
    return FilterUtils.getFilters({
      id,
      created_datetime,
      success_fail,
      message,
      error_message,
      method,
      iprofit_erp_module_enum,
      module_entity_code,
    });
  };

  useEffect(() => {
    let filteredParams = getFilteredParams();

    const params = {
      filters: filteredParams,
      offset: (parseInt(page) - 1) * rowsPerPage,
      page_size: rowsPerPage
    };

    switch (logOption) {
      case 'exceptions':
        dispatch(logActions.fetchExceptionLogs(params));
        break;
      case 'api-logs':
        dispatch(logActions.fetchAPILogs(params));
        break;
    }
  }, [page, filters, rowsPerPage, logOption]);

  const handlePageChange = (updatePage) => {
    if (!_.isEmpty(updatePage)) {
      let params = {
        ...filters,
        page: updatePage ? updatePage.current : 1,
      };
      history.push(FilterUtils.createUrl({ ...params }));
      if (updatePage.pageSize !== rowsPerPage) {
        setRowsPerPage(updatePage.pageSize);
      }
    }
  };

  const handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    let params = {
      ...filters,
    };
    switch (dataIndex) {
      default:
        delete params[dataIndex];

        if (dataIndex == 'iprofit_erp_module_enum') {
          delete params['module_entity_code'];
          history.push(FilterUtils.removeUrl('module_entity_code'));
        }
        setFilters(params);
        history.push(FilterUtils.removeUrl(dataIndex));
        break;
    }
  };

  const onFilterChange = (e, dataIndex, confirm) => {
    confirm();
    let params = {... filters};

    switch (dataIndex) {
      case 'id':
        params = {
          ...params,
          id: e,
        };
        break;
      case 'created_datetime':
        params = {
          ...params,
          created_datetime: e,
        };
        break;
      case 'success_fail':
        params = {
          ...params,
          success_fail: e,
        };
        break;
      case 'message':
        params = {
          ...params,
          message: e,
        };
        break;
      case 'error_message':
        params = {
          ...params,
          error_message: e,
        };
        break;
      case 'method':
        params = {
          ...params,
          method: e,
        };
        break;
      case 'iprofit_erp_module_enum':
        params = {
          ...params,
          iprofit_erp_module_enum: e,
        };
        break;
      case 'module_entity_code':
        params = {
          ...params,
          module_entity_code: e,
        };
        break;
      default:
        params = {
          ...params,
          [dataIndex]: e,
        };
        break;
    }
    setFilters(params);
    history.push(FilterUtils.createUrl({... params, activeTab}));
    setScrollToFirstRow(true);
  };

  const clearFilters = () => {
    const { type } = filters;
    const updatedFilters = type ? { type } : {};
    setFilters(updatedFilters);

    const params = new URLSearchParams('');
    params.set('page', 1);
    if (activeTabTemp) {
      params.set('activeTab', activeTabTemp);
    }
    if (type) {
      params.set('type', type);
    }

    let pathname = window.location.pathname;
    history.push(getUrlWithEncryptedQueryParams(`${pathname}?${params.toString()}`));
  };

  const getDateIcon = (filtered, dataIndex) => {
    return <CalendarOutlined style={{ color: filters.hasOwnProperty(dataIndex) ? 'var(--unnamed-color-1890ff)' : undefined }} />;
  };

  const getSearchIcon = (filtered, dataIndex) => {
    return <SearchOutlined style={{ color: filtered ? 'var(--unnamed-color-1890ff)' : undefined }} />;
  };

  const getFilteredIcon = (filtered, dataIndex) => {
    return <FilterOutlined style={{ color: filters.hasOwnProperty(dataIndex) ? 'var(--unnamed-color-1890ff)' : undefined }} />;
  };

  const totalRecords = _.get(logs, `[0].total_count`) || 0;

  // Column configurations for different options
  const getColumnsByLogOption = (option) => {
    switch (option) {
      case 'exceptions':
        return [
          {
            title: '#',
            dataIndex: 'id',
            width: '33px',
            align: 'left',
            sorter: (a, b) => a.id - b.id,
            render: (text, row) => <div className="bfc-table-list-components">{row?.id || '-'}</div>,
            filterDropdown: (props) => (
              <NumericSearchFilter
                dataIndex={'id'}
                data={props}
                onFilterChange={onFilterChange}
                handleReset={handleReset}
                value={id}
                name={'ID'}
                isDealDealiveryMultiselectFilter={true}
              />
            ),
            filterIcon: (filtered) => getSearchIcon(filtered, 'id'),
            filteredValue: id !== undefined ? id : null,
          },
          {
            title: 'Method',
            dataIndex: 'method',
            width: '150px',
            align: 'left',
            sorter: (a, b) => a.method && a.method.localeCompare(b.method && b.method),
            render: (text, row) => <div className="bfc-table-list-components">{row?.method || '-'}</div>,
            filterDropdown: (props) => (
              <TextSearchFilter
                dataIndex={'method'}
                data={props}
                onFilterChange={onFilterChange}
                handleReset={handleReset}
                value={method}
                name={'Method'}
              />
            ),
            filterIcon: (filtered) => getSearchIcon(filtered, 'method'),
            filteredValue: method !== undefined ? method : null,
          },
          {
            title: 'Message',
            dataIndex: 'message',
            width: '400px',
            align: 'left',
            sorter: (a, b) => a.message && a.message.localeCompare(b.message && b.message),
            render: (text, row) => <div className="bfc-table-list-components">{row?.message || '-'}</div>,
            filterDropdown: (props) => (
              <TextSearchFilter
                dataIndex={'message'}
                data={props}
                onFilterChange={onFilterChange}
                handleReset={handleReset}
                value={message}
                name={'Message'}
              />
            ),
            filterIcon: (filtered) => getSearchIcon(filtered, 'message'),
            filteredValue: message !== undefined ? message : null,
          },
          {
            title: 'Logged On',
            dataIndex: 'created_datetime',
            width: '150px',
            align: 'center',
            sorter: (a, b) => a.created_datetime && a.created_datetime.localeCompare(b.created_datetime && b.created_datetime),
            render: (text, row) => <ClosingDateField closing_on={row?.created_datetime} to_date={row?.created_datetime} />,
            filterDropdown: (props) => (
              <RangeDateSearchFilter
                dataIndex={'created_datetime'}
                data={props}
                onFilterChange={onFilterChange}
                handleReset={handleReset}
                value={created_datetime}
              />
            ),
            filterIcon: (filtered) => getDateIcon(filtered, 'created_datetime'),
            defaultFilteredValue: created_datetime !== undefined ? created_datetime : null,
          },
        ];

      case 'api-logs':
        return [
          {
            title: '#',
            dataIndex: 'id',
            width: '33px',
            align: 'left',
            sorter: (a, b) => a.id - b.id,
            render: (text, row) => <div className="bfc-table-list-components">{row?.id || '-'}</div>,
            filterDropdown: (props) => (
              <NumericSearchFilter
                dataIndex={'id'}
                data={props}
                onFilterChange={onFilterChange}
                handleReset={handleReset}
                value={id}
                name={'ID'}
                isDealDealiveryMultiselectFilter={true}
              />
            ),
            filterIcon: (filtered) => getSearchIcon(filtered, 'id'),
            filteredValue: id !== undefined ? id : null,
          },
          {
            title: 'Entity',
            dataIndex: 'module_entity_code',
            width: '100px',
            align: 'left',
            sorter: (a, b) => a.module_entity_code && a.module_entity_code.localeCompare(b.module_entity_code && b.module_entity_code),
            render: (text, row) => (
              <div className="bfc-table-list-components">
                {[6, 7, 8, 9].includes(row?.iprofit_erp_module_enum)
                  ? (
                      <Link to={getUrlWithEncryptedQueryParams(`/invoices/${row?.module_entity_id}`)}>
                        {row?.module_entity_code}
                      </Link>
                  )
                  : (
                    row?.module_entity_code || '-'
                  )}
              </div>),
            filterDropdown: (props) => (
              iprofit_erp_module_enum ?
              <TextSearchFilter
                dataIndex={'module_entity_code'}
                data={props}
                onFilterChange={onFilterChange}
                handleReset={handleReset}
                value={module_entity_code}
                name={'Entity'}
              /> : <div style={{padding: '3px'}}>Please filter by Module first</div>
            ),
            filterIcon: (filtered) => getSearchIcon(filtered, 'module_entity_code'),
            filteredValue: module_entity_code !== undefined ? module_entity_code : null,
          },
          {
            title: 'Module',
            dataIndex: 'iprofit_erp_module_enum_code',
            width: '80px',
            align: 'left',
            sorter: (a, b) => a.iprofit_erp_module_enum_code && a.iprofit_erp_module_enum_code.localeCompare(b.iprofit_erp_module_enum_code && b.iprofit_erp_module_enum_code),
            render: (text, row) => <div className="bfc-table-list-components">{row?.iprofit_erp_module_enum_code || '-'}</div>,
            filterDropdown: (props) => (
              <AutoCompleteFilter
                dataIndex={'iprofit_erp_module_enum'}
                data={props}
                onFilterChange={onFilterChange}
                handleReset={handleReset}
                value={iprofit_erp_module_enum}
                name={'Module'}
                isSendEnum={true}
              />
            ),
            filterIcon: (filtered) => getFilteredIcon(filtered, 'iprofit_erp_module_enum'),
            defaultFilteredValue: iprofit_erp_module_enum !== undefined ? iprofit_erp_module_enum : null,
          },
          {
            title: 'Message',
            dataIndex: 'error_message',
            width: '400px',
            align: 'left',
            sorter: (a, b) => a.error_message && a.error_message.localeCompare(b.error_message && b.error_message),
            render: (text, row) => <div className="bfc-table-list-components">{row?.error_message || '-'}</div>,
            filterDropdown: (props) => (
              <TextSearchFilter
                dataIndex={'error_message'}
                data={props}
                onFilterChange={onFilterChange}
                handleReset={handleReset}
                value={error_message}
                name={'Message'}
              />
            ),
            filterIcon: (filtered) => getSearchIcon(filtered, 'error_message'),
            filteredValue: error_message !== undefined ? error_message : null,
          },
          {
            title: 'Logged On',
            dataIndex: 'created_datetime',
            width: '60px',
            align: 'center',
            sorter: (a, b) => a.created_datetime && a.created_datetime.localeCompare(b.created_datetime && b.created_datetime),
            render: (text, row) => <ClosingDateField closing_on={row?.created_datetime} to_date={row?.created_datetime} />,
            filterDropdown: (props) => (
              <RangeDateSearchFilter
                dataIndex={'created_datetime'}
                data={props}
                onFilterChange={onFilterChange}
                handleReset={handleReset}
                value={created_datetime}
              />
            ),
            filterIcon: (filtered) => getDateIcon(filtered, 'created_datetime'),
            defaultFilteredValue: created_datetime !== undefined ? created_datetime : null,
          },
          {
            title: 'Status',
            dataIndex: 'is_successful',
            width: '30px',
            align: 'center',
            render: (text, row) => (
              <div className="d-flex justify-content-between align-items-center">
                {row?.is_successful != true ? (
                  <>
                    <CancelIcon className="ml-1" style={{ color: 'var(--unnamed-color-f44336)' }} />
                  </>
                ) : (
                  ''
                )}
              </div>
            ),
            filterDropdown: (props) => (
              <AutoCompleteFilter
                dataIndex={'success_fail'}
                data={props}
                onFilterChange={onFilterChange}
                handleReset={handleReset}
                value={success_fail}
                name={'Status'}
              />
            ),
            filterIcon: (filtered) => getFilteredIcon(filtered, 'success_fail'),
            filteredValue: success_fail !== undefined ? success_fail : null,
          },
          {
            title: 'Retry',
            width: '30px',
            align: 'center',
            render: (text, row) => (
              <div className="d-flex justify-content-between align-items-center">
                {[2,3,4,5,6,7,8,9].includes(row?.iprofit_erp_module_enum) && (
                  <MUIButton
                  type="icon"
                  variant="text"
                  Icon={RetryIcon}
                  iconBtnSize="small"
                  onClick={async () => {
                    switch (row?.iprofit_erp_module_enum)
                    {
                      case 3:
                        await iProfitERPService.saveUpdateVendor({ pcA_Id: row?.module_entity_id, pcA_Enum: row?.person_company_affiliate_enum });
                        break;
                      case 2:
                        await iProfitERPService.saveUpdateCustomer({ pcA_Id: row?.module_entity_id, pcA_Enum: row?.person_company_affiliate_enum });
                        break;
                      case 5:
                        await iProfitERPService.saveUpdateTaxInfo({ pcA_Id: row?.module_entity_id, pcA_Enum: row?.person_company_affiliate_enum, sourceTypeEnum: row?.iprofiterpsourcetypeenum });
                        break;
                      case 4:
                        await iProfitERPService.saveUpdateAddress({ company_Address_Id: row?.module_entity_id, iProfitERPAddressTypeEnum: row?.iprofiterpaddresstypeenum, sourceTypeEnum: row?.iprofiterpsourcetypeenum });
                        break;
                      case 6:
                      case 7:
                      case 8:
                      case 9:
                        await iProfitERPService.saveUpdateInvoice({ invoice_Master_Id: row?.module_entity_id });
                        break;
                      default:
                        break;
                    }

                    let filteredParams = getFilteredParams();

                    const params = {
                      filters: filteredParams,
                      offset: 0,
                      page_size: rowsPerPage
                    };

                    dispatch(logActions.fetchAPILogs(params));
                  }}
                  />)
                }
              </div>
            )
          },
        ];

      default:
        return [];
    }
  };

  const TABLE_HEADERS = getColumnsByLogOption(logOption);

  return (
    <>
      <div className="bfc-header">
        <TableListHeader
          links={links}
          rightPanContent={
            <>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '8px', position: 'relative' }}>
                <div style={{ width: 190, marginRight: 16 }}>
                  <MUIAutocomplete
                    key={logOption}
                    label="Select Type"
                    data={logOptions}
                    dataStructure={{ labelApiParam: 'label', valueApiParam: 'value' }}
                    apiParams={{}}
                    selectedCodeOrId={logOption}
                    disableClearable={true}
                    onChange={(value, setValue) => {
                      if (value) {
                        setLogOption(value.value);

                        const qParams = new URLSearchParams('');
                        qParams.set('page', 1);
                        qParams.set('activeTab', activeTab);
                        qParams.set('lOption', value.value);

                        history.push(getUrlWithEncryptedQueryParams(`${window.location.pathname}?${qParams.toString()}`));
                      }
                    }}
                  />
                </div>
              </div>
            </>
          } />
      </div>
      <div className="bfc-body">
        <div className="blocked-table">
          <div className="ant-table-body ant-table">
            {
              <>
                <Table
                  ref={tableRef}
                  dataSource={!busy ? logs : [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}]}
                  columns={busy ? TABLE_HEADERS.map((column) => {
                    return {
                      ...column,
                      render: function renderPlaceholder() {
                        return (
                          <Skeleton
                            active="true"
                            key={column.dataIndex}
                            title={true}
                            paragraph={false}
                          />
                        );
                      },
                    };
                  }) : TABLE_HEADERS}
                  pagination={false}
                  onChange={handlePageChange}
                  scroll={{ y: 550 }}
                  className="ant-table"
                  size="small"
                />
                {totalRecords > 0 && (
                  <AntPagination
                    total={parseInt(totalRecords)}
                    handlePageChange={handlePageChange}
                    page={page}
                    clearFilters={clearFilters}
                    rowsPerPage={rowsPerPage}
                    setScrollToFirstRow={setScrollToFirstRow}
                  />
                )}
              </>
            }
          </div>
        </div>
      </div>
    </>
  );
};
export default Logs;
